import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('TaskMenus?page=' + page,  {params});
    }, 
    show(id) {
        return Service().get('TaskMenus/show/'+id);
    },    
    create(params) {
        return Service().post('TaskMenus/create', params);
    },
    update(id, params) {
        return Service().post('TaskMenus/update/'+id, params);
    },
    delete(id) {
        return Service().post('TaskMenus/delete/'+id);
    },
    update_sequence(params) {
        return Service().post('TaskMenus/update-sequence', params);
    },
}